module.exports = __webpack_public_path__ + "static/r12-e2e0217152a56e18a7fb07e416965256.jpg";